import './App.scss';
import Form from "./components/Form";
import { Redirect, Route, BrowserRouter as Router } from "react-router-dom";
import { config } from './config';
import { useEffect } from 'react';
import { Header } from './models';
import React from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { textSpanIsEmpty } from 'typescript';

function App2(props) {

    const readDsgvoCookie = (name) => {

        // Split cookie string and get all individual name=value pairs in an array
        var cookieArr = document.cookie.split(";");

        // Loop through the array elements
        for (var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i];

            /* Removing whitespace at the beginning of the cookie name
            and compare it with the given string */
            if (name == cookiePair) {
                // Decode the cookie value and return
                return decodeURIComponent(cookiePair[1]);
            }
        }

        // Return null if not found
        return null;
    }

    var lng = "en";

    if (window.location.pathname.startsWith('/de')) {
        lng = "de";
    }
    else if (window.location.pathname.startsWith('/en')) {
        lng = "en";
    }
    else if (window.location.pathname.startsWith('/es')) {
        lng = "es";
    }

    const [language, setLanguage] = React.useState<string>(lng);
    const [labelAnfrageformular, setLabelAnfrageformular] = React.useState("TO APPLICATION REQUEST");
    const [privacyUrl, setPrivacyUrl] = React.useState("");
    const [privacyLabel, setPrivacyLabel] = React.useState("");
    const [subTitleSystem, setSubTitleSystem] = React.useState("");
    const [header, setHeader] = React.useState<any>({});
    const [showMoreContent, setShowMoreContent] = React.useState<boolean>(false);

    const [BtnDeclineLabel, setBtnDeclineLabel] = React.useState<any>("");
    const [BtnAcceptLabel, setBtnAcceptLabel] = React.useState<any>("");
    const [visible, setVisible] = React.useState(readDsgvoCookie("__gfa=GFAUmfrageDsgvo" + lng) == null ? true : false);
    const toggleDialog = () => {
        setVisible(!visible);

        writeDsgvoCookie();
    };

    const showMoreDialog = () => {
        setShowMoreContent(!showMoreContent);
    }

    const writeDsgvoCookie = () => {
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + 1000 * 36000;
        now.setTime(expireTime);
        document.cookie = '__gfa=GFAUmfrageDsgvo' + lng + ';expires=' + now.toUTCString() + ';path=/';
    }

    const changeLanguage = (lang) => {

        window.location.href = config.Host + "" + lang;

        setLanguage(lang);

    }

    useEffect(() => {
        fetch(`${config.Umfrage_URL}header`,
            {
                headers: {
                    "LANG": lng
                }
            }).then((response) => {
                var json = response.json();
                return json;
            }).then(function (resp: any) {
                const header: Header = resp;

                setHeader(header);
            });
    }, [lng]);

    useEffect(() => {
        switch (language) {
            case "de":
                setLabelAnfrageformular("ZUM ANFRAGEFORMULAR");
                setBtnAcceptLabel("Akzeptieren");
                setBtnDeclineLabel("Mehr anzeigen");
                setPrivacyLabel("Datenschutz");
                setPrivacyUrl("https://www.gfa-cert.com/datenschutz/");
                break;
            case "en":
                setLabelAnfrageformular("TO APPLICATION REQUEST");
                setBtnAcceptLabel("Accept");
                setBtnDeclineLabel("Show more");
                setPrivacyLabel("Data privacy");
                setPrivacyUrl("https://www.gfa-cert.com/en/data-privacy/");
                break;
            case "es":
                setLabelAnfrageformular("TO SOLICITUD DE SOLICITUD");
                setBtnAcceptLabel("Aceptar");
                setBtnDeclineLabel("mostrar más");
                setPrivacyLabel("Protección de datos");
                setPrivacyUrl("https://www.gfa-cert.com/es/datenschutz/");
                break;
        }
    });

    return (
        <>

            <nav className="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
                <div className="container">
                    <a className="navbar-brand" href="#page-top"><img id="logo" src="assets/gfa.svg" alt="Logo" /></a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                        Menu
                        <i className="fas fa-bars ms-1"></i>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                        <ul className="navbar-nav text-uppercase ms-auto py-4 py-lg-0">

                            <li className="nav-item"><a className="nav-link" href="#services">GFA Application</a></li>
                            <li onClick={() => changeLanguage("de")} style={{ lineHeight: "34px", cursor: "pointer" }} className='nav-item'>
                                <img

                                    src="https://www.gfa-cert.com/wp-content/plugins/sitepress-multilingual-cms/res/flags/de.png"
                                    alt=""
                                />
                            </li>
                            <li onClick={() => changeLanguage("en")} style={{ lineHeight: "34px", cursor: "pointer" }} className='nav-item'>
                                <img

                                    src="https://www.gfa-cert.com/wp-content/plugins/sitepress-multilingual-cms/res/flags/en.png"
                                    alt=""
                                />
                            </li>
                            <li onClick={() => changeLanguage("es")} style={{ lineHeight: "34px", cursor: "pointer" }} className='nav-item'>
                                <img

                                    src="https://www.gfa-cert.com/wp-content/plugins/sitepress-multilingual-cms/res/flags/es.png"
                                    alt=""
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <header className="masthead">
                <div className="header">
                    <div className="container">
                        <div className="masthead-subheading">{header.title}</div>
                        <div style={{ fontSize: "16px", fontFamily: 'Varela Round', color: "white", margin: "10px 10px 30px 0px" }} className="text-uppercase ">{header.description}</div>
                        <a className="btn btn-primary btn-xl text-uppercase" href="#services">{labelAnfrageformular}</a>
                    </div>
                </div>
            </header>

            <section className="page-section" id="services">
                <div className="container">
                    <Router>
                        <Route exact path="/:language" render={(props) => <Form titleSystem={header.system_Header} subTitleSystem={header.system_Body} {...props} />} />
                        <Route
                            exact
                            path="/"
                            render={() => {
                                return (
                                    <Redirect to="/en" />
                                )
                            }}
                        />
                    </Router>
                </div>
            </section>


            <section className="page-section" id="contact">
                <div className="container">
                    <div className="text-center">
                        <h2 className="section-heading text-uppercase">Kontakt</h2>
                        <div className="contact">
                            GFA Certification GmbH<br />
                            Alter Teichweg 15<br />
                            22081 Hamburg<br />
                            Deutschland<br /><br />

                            +49 40 52474310<br />
                            info@gfa-cert.com<br />
                        </div>
                    </div>

                </div>
            </section>

            <footer className="footer py-4">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-4 text-lg-start">Copyright &copy; GFA 2022</div>
                
                        <div className="col-lg-4 text-lg-end">
                            <a className="link-dark text-decoration-none me-3" href={privacyUrl}>{privacyLabel}</a>
                        </div>
                    </div>
                </div>
            </footer>


            {visible &&
                <Dialog title={header.cookie_Header} width={"90%"}  onClose={toggleDialog}>
                    <div style={{ overflowY: "scroll", maxHeight: "60vh"}} >
                        <p
                            style={{
                                margin: "25px",
                                textAlign: "center",
                                fontFamily: "Varela Round",
                                fontWeight:600
                            }}
                        >
                            {header.cookie_Body}
                        </p>
                        {showMoreContent &&
                            <p  style={{
                                margin: "25px",
                                textAlign: "center",
                                fontFamily: "Varela Round",
                            }}>
                               {header.cookie_Body_MoreContent}
                            </p>
                        }
                    </div>
                    <DialogActionsBar>
                        { !showMoreContent &&
                            <button
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                onClick={showMoreDialog}
                            >
                                {BtnDeclineLabel}
                            </button>
                        }
                        <button
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                            onClick={toggleDialog}
                        >
                            {BtnAcceptLabel}
                        </button>
                    </DialogActionsBar>
                </Dialog>
            }
        </>
    );
}

export default App2;
